import Model from './Model'

export default class User extends Model {
  resource() {
    return 'superadmin/users/staff'
  }
}
